module.exports = __webpack_public_path__ + "static/orc_red_fang_of_shargaas-91e95b5cf85c13c96353fa68c67ea33f.jpeg";